import { dayjsLocal } from '@/shared/utilities/dayjs-local';
import { ArrowDropDown, CalendarToday, ChevronLeft, ChevronRight } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/CloseRounded';
import type { Components, CssVarsTheme } from '@mui/material/styles';
import type { Dayjs } from 'dayjs';
import { createElement } from 'react';

const slots = {
  openPickerIcon: () => createElement(CalendarToday, { className: 'size-4' }),
  leftArrowIcon: () => createElement(ChevronLeft, { className: 'size-4' }),
  rightArrowIcon: () => createElement(ChevronRight, { className: 'size-4' }),
  switchViewIcon: () => createElement(ArrowDropDown, { className: 'size-4' }),
  clearIcon: () => createElement(CloseIcon, { className: 'size-4' })
};

const dayOfWeekFormatter = (date: Dayjs) => {
  const day = date.format('dd');
  const mapping: Record<string, string> = {
    CN: 'CN',
    T2: 'T2',
    T3: 'T3',
    T4: 'T4',
    T5: 'T5',
    T6: 'T6',
    T7: 'T7',
    Su: 'CN',
    Mo: 'T2',
    Tu: 'T3',
    We: 'T4',
    Th: 'T5',
    Fr: 'T6',
    Sa: 'T7'
  };
  return mapping[day] || day;
};

export const MuiDatePicker: Components<CssVarsTheme>['MuiDatePicker'] = {
  defaultProps: {
    slots,
    dayOfWeekFormatter,
    referenceDate: dayjsLocal().utcOffset(0, false),
    slotProps: {
      textField: {
        size: 'small',
        InputLabelProps: {
          shrink: true
        }
      },
      field: {
        clearable: true
      }
    },
    format: 'DD/MM/YYYY'
  }
};
export const MuiDateTimePicker: Components<CssVarsTheme>['MuiDateTimePicker'] = {
  defaultProps: {
    slots
  }
};

export const MuiStaticDatePicker: Components<CssVarsTheme>['MuiStaticDatePicker'] = {
  defaultProps: {
    slots
  }
};

export const MuiDesktopDatePicker: Components<CssVarsTheme>['MuiDesktopDatePicker'] = {
  defaultProps: {
    slots,
    slotProps: {
      textField: {
        size: 'small',
        slotProps: {
          inputLabel: {
            shrink: true
          }
        }
      }
    }
  }
};

export const MuiDesktopDateTimePicker: Components<CssVarsTheme>['MuiDesktopDateTimePicker'] = {
  defaultProps: {
    slots
  }
};

export const MuiMobileDatePicker: Components<CssVarsTheme>['MuiMobileDatePicker'] = {
  defaultProps: {
    slots,
    slotProps: {
      textField: {
        size: 'small',
        slotProps: {
          inputLabel: {
            shrink: true
          }
        }
      }
    }
  }
};

export const MuiMobileDateTimePicker: Components<CssVarsTheme>['MuiMobileDateTimePicker'] = {
  defaultProps: {
    slots
  }
};

export const MuiMultiSectionDigitalClock: Components<CssVarsTheme>['MuiMultiSectionDigitalClock'] = {
  styleOverrides: {
    root: {
      '& .MuiMultiSectionDigitalClockSection-root': {
        '&::-webkit-scrollbar': {
          width: '4px'
        }
      }
    }
  }
};
